module.exports = __webpack_public_path__ + "img/hqw_a.ecfa50ab.jpg";